/**
 * Builds a map of reaction emoji keyed by target message ID.
 * Only keeps the last reaction per mID (WhatsApp allows one reaction per message).
 *
 * @param {object[]} messages - Array of message objects
 * @returns {object} Map of mID → reaction emoji string
 * @example
 * buildReactionsByMID(messages)
 * // { "abc123": "👍", "def456": "❤️" }
 */
export function buildReactionsByMID(messages) {
	const reactionsByMID = {};
	messages.forEach(msg => {
		if (msg?.payload?.header?.type === "reaction") {
			const mID = msg?.header?.externalInfos?.mID;
			if (mID) reactionsByMID[mID] = msg?.payload?.payload?.reaction;
		}
	});
	return reactionsByMID;
}
